/**
 * Shared canvas height for GHG inventory Chart.js charts (inventory comparison, sectors, etc.).
 * Used as both `height` and `minHeight` on chart wrapper divs.
 */
export const GHG_INVENTORY_CHART_HEIGHT_PX = 420;
